var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSelected(_vm.value))?_c('div',{staticClass:"col product-tag",style:({ backgroundColor: _vm.color}),on:{"click":function($event){return _vm.remove(_vm.value)}}},[_c('span',{staticClass:"product-tag-lable"},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"tag-close",attrs:{"value":_vm.value}},[_vm._v(" X ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }